var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/core-js/library/modules/_core.js
// module id = cRQ2
// module chunks = 0